<template>
  <a-modal
    :visible.sync="isVisible"
    :confirmLoading="loading"
    :maskClosable="false"
    :title="title"
    @ok="handleOk"
    @cancel="handleCancel">
    <a-form :form="form">
      <a-form-item label="厂商名称" :labelCol="{ sm: 8, md: 5 }" :wrapperCol="{ sm: 16, md: 17 }">
        <a-input
          placeholder="请输入第三方Launcher提供商名称"
          v-decorator="['vendorName', {
            rules: [{ required: true, message: '名称不能为空' },
                    { pattern: /^[\u4E00-\u9FA5\uF900-\uFA2Da-zA-Z0-9]{2,40}$/, message: '输入字符必须是长度2~40的中英文和数字' }],
            validateTrigger: 'blur'
          }]"/>
      </a-form-item>
      <a-form-item label="联系方式" :labelCol="{ sm: 8, md: 5 }" :wrapperCol="{ sm: 16, md: 17 }">
        <a-input
          placeholder="请输入联系方式"
          v-decorator="['contact', {
            rules: [{ max: 30, message: '最长不超过30个字符' }]
          }]"/>
      </a-form-item>
      <a-form-item label="地址" :labelCol="{ sm: 8, md: 5 }" :wrapperCol="{ sm: 16, md: 17 }">
        <a-input
          placeholder="请输入厂商所在地址"
          v-decorator="['address', {
            rules: [{ max: 50, message: '地址最长不超过50个字符' }]
          }]"/>
      </a-form-item>
      <a-form-item label="显示顺序" :labelCol="{ sm: 8, md: 5 }" :wrapperCol="{ sm: 16, md: 17 }">
        <a-input-number
          :min="1"
          :max="999"
          v-decorator="['sort', {
            rules: [{ required: true, message: '显示顺序限制1-999之间' }],
            initialValue: 50
          }]"/>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { createAppVendor, updateAppVendor } from '@/api/vendor'

export default {
  props: {
    visible: {
      required: true,
      type: Boolean
    }
  },

  data () {
    return {
      form: this.$form.createForm(this),
      loading: false,
      id: ''
    }
  },

  computed: {
    isVisible: {
      get: function () {
        return this.visible
      },
      set: function (val) {
        this.$emit('update:visible', val)
      }
    },

    title () {
      return this.id ? '编辑第三方Launcher提供商' : '新增第三方Launcher提供商'
    }
  },

  methods: {
    load (vendor) {
      if (vendor && vendor.id) {
        this.id = vendor.id
        this.$nextTick(() => {
          this.form.setFieldsValue({
            vendorName: vendor.name,
            contact: vendor.contact,
            address: vendor.address,
            sort: vendor.sort
          })
        })
      }
    },

    handleOk () {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true
          if (this.id) {
            updateAppVendor(this.id, values).then(response => {
              this.$message.success(response.msg)
              this.$emit('ok', values)
              this.handleCancel()
            }).catch(err => {
              console.log(err)
            }).finally(() => {
              this.loading = false
            })
          } else {
            createAppVendor(values).then(response => {
              this.$message.success(response.msg)
              this.$emit('ok')
              this.handleCancel()
            }).catch(err => {
              console.log(err)
            }).finally(() => {
              this.loading = false
            })
          }
        } else {
          this.loading = false
        }
      })
    },

    handleCancel () {
      this.id = ''
      this.isVisible = false
      this.form.resetFields()
    }
  }
}
</script>

<style scoped>

</style>
